// extracted by mini-css-extract-plugin
export var chevron = "_gx-4";
export var chevronExpanded = "_gx-5";
export var row = "_gx-0";
export var rowBody = "_gx-6";
export var rowDescription = "_gx-7";
export var rowHeader = "_gx-1";
export var rowTitle = "_gx-2";
export var rowTitleComplete = "_gx-3";